import React from 'react'
import { CircularProgress, Box, Typography } from '@mui/material';
import '../../styles/DobleCircularProgressWithLabel.css'

export const DobleCircularProgressWithLabel = ({ percentage, size, fontSize }) => {

    return (
        <Box sx={{ position: 'relative', height: size }}>
            <Box>
                <CircularProgress
                    variant="determinate"
                    sx={{
                        color: 'rgb(158, 188, 214)'
                    }}
                    size={size}
                    value={100}
                />
            </Box>
            <Box className='floatingText'>
                <CircularProgress variant="determinate" value={percentage} size={size} />
            </Box>
            <Box className='floatingText'>
                <Typography variant="caption" component="div" color="text.blue" sx={{ fontWeight: 'bold', fontSize: fontSize }}>
                    {`${percentage}%`}
                </Typography>
            </Box>
        </Box>

    )
}